import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "relative w-full h-full flex-grow flex overflow-hidden" }
const _hoisted_2 = {
  key: 0,
  class: "min-h-300 absolute top-0 left-0 right-0 bottom-0 flex flex-col items-center justify-center gap-4"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "Loading virtual mailbox...", -1)
const _hoisted_4 = { class: "max-w-sm" }
const _hoisted_5 = {
  key: 0,
  class: "max-w-sm"
}
const _hoisted_6 = { class: "max-w-sm" }
const _hoisted_7 = { class: "w-full mb-4 max-w-sm" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  class: "mb-3 block",
  htmlFor: "assigned_box_number"
}, " Unit Number ", -1)
const _hoisted_9 = { class: "flex w-full" }
const _hoisted_10 = { class: "flex flex-col pt-1" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs" }, "Choose a number between 0001-5000", -1)
const _hoisted_12 = { class: "max-w-sm" }
const _hoisted_13 = { class: "max-w-sm" }
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<div class=\"lg:w-100 w-120 h-full border-solid border-0 border-l outline-none details-block flex flex-col gap-4 p-4 flex-shrink-0\"><p>Virtual Mailbox Overview</p><p class=\"text-13\"> Setup a virtual mailbox in one of our secure mail processing facilities. </p><ul class=\"text-13 list-disc pl-4\"><li class=\"mb-1\"> Mail is scanned within 24 hours of receipt (usually faster) </li><li class=\"mb-1\"> Set your team members that have access to this mailbox </li><li class=\"mb-1\"> Any mail can be selected for forwarding to your address of your choosing for a $1.50 fee + cost of shipping </li><li class=\"mb-1\"> Email notifications can be sent to the team when new mail arrives as either the full PDF or a link back to Thatch for more secure viewing </li></ul></div>", 1)

import { useRoute, useRouter } from 'vue-router';
import {
	required,
	minLength,
	maxLength,
	requiredIf
} from '@vuelidate/validators';
import { computed, watch } from 'vue';
import {
	UiLoader,
	UiCard,
	UiCardDivider,
	useForm,
	UiForm,
	UiInput,
	UiRadioTabs,
	UiButton,
	UiSelect,
	SelectOptions,
	UiFormError
} from '@/ui-kit';
import { useVirtualMailbox } from '../use-virtual-mailbox';
import { httpService, Nullable } from '@/utils';
import { Mailbox } from '../mailbox';
import { useBilling } from '@/billing';
import { useCompanyProfile } from '@/account';


export default /*#__PURE__*/_defineComponent({
  __name: 'AddVirtualMailbox',
  setup(__props) {

const { isLoading, locations, items, setMailboxItem } =
	useVirtualMailbox();
const { currentSubItems } = useBilling();
const { isPaidAccount } = useCompanyProfile();

const route = useRoute();
const router = useRouter();

const virtualMailboxSubscriptions = computed(() => {
	return currentSubItems.value
		.filter(
			(item) =>
				item.subscriptionName ===
					'virtual-mail-system' &&
				items.value.filter(
					(mailbox) =>
						mailbox.subscription_item
							.stripe_product ===
						item.stripe_product
				).length < item.quantity
		)
		.map((item) => ({
			value: item.id,
			title: item.friendlyName
		}));
});

const { formData, validator, onSubmit, loading } = useForm(
	{
		friendly_name: '',
		assigned_box_number: null as Nullable<number>,
		auto_ocr: 1,
		allow_pdf_to_team: 1,
		physical_address_id: route.params.location
			? Number(route.params.location)
			: locations.value[0]?.id,
		subscription_item_id:
			virtualMailboxSubscriptions.value[0]?.value ||
			(null as Nullable<number>)
	},
	{
		friendly_name: {
			required
		},
		assigned_box_number: {
			required,
			minLength: minLength(4),
			maxLength: maxLength(4)
		},
		auto_ocr: {
			required
		},
		allow_pdf_to_team: {
			required
		},
		physical_address_id: {
			required
		},
		subscription_item_id: {
			required: requiredIf(() => isPaidAccount.value)
		}
	}
);

const options = computed<SelectOptions>(() => {
	return locations.value.map((loc) => ({
		title: `${loc.line}, ${loc.city} ${loc.state} ${loc.zip}`,
		value: loc.id
	}));
});

const hasUntNumberError = computed(() => {
	return validator.value.assigned_box_number.$error;
});

const selectedLocation = computed(() => {
	return locations.value.find(
		(loc) =>
			loc.id === Number(formData.physical_address_id)
	);
});

const yesNoOption: SelectOptions = [
	{
		title: 'Yes',
		value: 1
	},
	{
		title: 'No',
		value: 0
	}
];

const createMailbox = onSubmit(async (data) => {
	const body = Object.entries(data).reduce(
		(acc, [key, value]) =>
			value === null ? acc : { ...acc, [key]: value },
		{}
	);
	const item = await httpService.post<Mailbox>(
		'company/virtual-mailbox/items',
		body
	);
	setMailboxItem(item);
	router.push({
		name: 'EditVirtualMailbox',
		params: { id: item.id }
	});
});

watch(
	isLoading,
	() => {
		if (!isLoading.value) {
			formData.physical_address_id =
				locations.value[0]?.id;
		}
	},
	{
		immediate: true
	}
);

const { isLoaded } = useBilling();

watch(
	isLoaded,
	() => {
		if (isLoaded.value) {
			formData.subscription_item_id =
				virtualMailboxSubscriptions.value[0]
					?.value || null;
		}
	},
	{
		immediate: true
	}
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(UiCard), {
      title: "Virtual Mailbox",
      class: "w-full p-4"
    }, {
      default: _withCtx(() => [
        (_unref(isLoading) || !_unref(isLoaded))
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _hoisted_3,
              _createVNode(_unref(UiLoader))
            ]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(_unref(UiCardDivider), { title: "Setup a virtual mailbox" }),
              _createVNode(_unref(UiForm), { onSubmit: _unref(createMailbox) }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_unref(UiInput), {
                      disabled: _unref(loading),
                      label: "Name",
                      placeholder: "Enter friendly name",
                      name: "friendly_name",
                      modelValue: _unref(formData).friendly_name,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(formData).friendly_name) = $event))
                    }, null, 8, ["disabled", "modelValue"])
                  ]),
                  (_unref(isPaidAccount))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createVNode(_unref(UiSelect), {
                          disabled: _unref(loading),
                          label: "Subscription",
                          placeholder: "Choose subscription for the box",
                          name: "physical_address_id",
                          modelValue: 
								_unref(formData).subscription_item_id
							,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((
								_unref(formData).subscription_item_id
							) = $event)),
                          options: 
								_unref(virtualMailboxSubscriptions)
							
                        }, null, 8, ["disabled", "modelValue", "options"])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_unref(UiSelect), {
                      disabled: _unref(loading),
                      label: "Location",
                      placeholder: "Choose location",
                      name: "physical_address_id",
                      modelValue: 
								_unref(formData).physical_address_id
							,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((
								_unref(formData).physical_address_id
							) = $event)),
                      options: _unref(options)
                    }, null, 8, ["disabled", "modelValue", "options"])
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _hoisted_8,
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["flex-shrink-0 pl-3 pr-6 border-0 transition border-0 border-b border-l border-t border-solid h-9.5 flex items-center bg-dark-blue-300 bg-opacity-25", 
									_unref(hasUntNumberError)
										? 'border-red-400'
										: 'border-dark-blue-300'
								])
                      }, _toDisplayString(_unref(selectedLocation)?.prefix), 3),
                      _createVNode(_unref(UiInput), {
                        disabled: _unref(loading),
                        class: "!mb-0 w-full",
                        noValidate: "",
                        name: "assigned_box_number",
                        placeholder: "Enter unit number",
                        modelValue: 
									_unref(formData).assigned_box_number
								,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((
									_unref(formData).assigned_box_number
								) = $event))
                      }, null, 8, ["disabled", "modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _hoisted_11,
                      _createVNode(_unref(UiFormError), { name: "assigned_box_number" })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_unref(UiRadioTabs), {
                      disabled: _unref(loading),
                      label: "Auto-OCR Incoming Mail",
                      name: "auto_ocr",
                      options: yesNoOption,
                      modelValue: _unref(formData).auto_ocr,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(formData).auto_ocr) = $event))
                    }, null, 8, ["disabled", "modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_unref(UiRadioTabs), {
                      disabled: _unref(loading),
                      label: "Allow PDF Email to Team",
                      name: "allow_pdf_to_team",
                      modelValue: 
								_unref(formData).allow_pdf_to_team
							,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((
								_unref(formData).allow_pdf_to_team
							) = $event)),
                      options: yesNoOption
                    }, null, 8, ["disabled", "modelValue"])
                  ]),
                  _createVNode(_unref(UiButton), { loading: _unref(loading) }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Continue setup ")
                    ]),
                    _: 1
                  }, 8, ["loading"])
                ]),
                _: 1
              }, 8, ["onSubmit"])
            ], 64))
      ]),
      _: 1
    }),
    _hoisted_14
  ]))
}
}

})